/*
Sohel 09/24/2023 5155351299 Added Extended Repository Table.
Sohel 09/26/2023 5155351299 Added Delete Functionality
Sohel 09/29/2023  5155351299 Extended Repository Added Field Description
Sohel 10/06/2023 5155351299 Fixed Extended Field Delete Record Issue
*/
import {IconButton, TextField, Tooltip} from '@material-ui/core';
import {DeleteOutlined} from '@material-ui/icons';
import React, {useState, useRef} from 'react';
import {withField} from '../../../DataManager/DataManagerRecord/AddDataManagerRecord/RecordFormatFieldsComponents/withField';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {getIn} from 'formik';
import {ErrorTooltip} from '../../../../../components/Tooltips';
import PageLoader from '../../../../../components/PageLoader';

function ExtendedRepositoryTable(props) {
  const {
    name,
    value: current,
    setFieldValue,
    key,
    touched,
    errors,
    values,
  } = props;
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const codeRef = useRef();
  const currentFieldError = (currFieldName) =>
    getIn(touched, name + '.' + currFieldName) ? getIn(errors, name + '.' + currFieldName) : '';
  const handleClose = () => {
    setIsDelete(false);
  };
  const handleConfirmDelete = () => {
    setIsLoading(true);
    return new Promise((resolve) => {
      setTimeout(() => {
        setIsLoading(false);
        resolve();
        // drArrayHelpers.current.remove(key);
        const data = [...values.fields]?.filter(
          (i) => i.baseFieldName !== current.baseFieldName,
        );
        setFieldValue('fields', data);
        handleClose();
      }, 1000);
    });
  };
  return (
    <>
      <tr key={key}>
        <td className="recFormat-col recFormat-center new-standard-textfields ">
          <Tooltip title="Delete">
            <IconButton
              onClick={() => {
                setIsDelete(true);
              }}
            >
              <DeleteOutlined />
            </IconButton>
          </Tooltip>
        </td>
        <td className="recFormat-col global-field-textfields ">{current?.baseFieldName}</td>

        <td className="recFormat-col global-field-textfields">
          <ErrorTooltip
            title={currentFieldError('fieldName')?.length > 0 ? currentFieldError('fieldName') : ''}
          >
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              className="textfield-block"
              InputLabelProps={{
                shrink: true,
              }}
              name={name + '.fieldName'}
              error={currentFieldError('fieldName')}
              value={current?.fieldName}
              inputRef={codeRef}
              onChange={(e) => {
                setFieldValue(name + '.fieldName', e.target.value);
                // let value = upperCaseCode(codeRef);
                // setFieldValue(name + ".fieldName", value?.replaceAll(" ", "_"));
              }}
            />
          </ErrorTooltip>
        </td>
        <td className="recFormat-col global-field-textfields">
          <ErrorTooltip
            title={
              currentFieldError('extendedFieldLabel')?.length > 0 ?
                currentFieldError('extendedFieldLabel') :
                ''
            }
          >
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              className="textfield-block"
              InputLabelProps={{
                shrink: true,
              }}
              name={name + '.extendedFieldLabel'}
              error={currentFieldError('extendedFieldLabel')}
              value={current?.extendedFieldLabel}
              onChange={(e) => {
                setFieldValue(name + '.extendedFieldLabel', e.target.value);
              }}
            />
          </ErrorTooltip>
        </td>
        <td className="recFormat-col global-field-textfields">
          <ErrorTooltip
            title={
              currentFieldError('extendedFieldDescription')?.length > 0 ?
                currentFieldError('extendedFieldDescription') :
                ''
            }
          >
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              className="textfield-block"
              InputLabelProps={{
                shrink: true,
              }}
              name={name + '.extendedFieldDescription'}
              error={currentFieldError('extendedFieldDescription')}
              value={current?.extendedFieldDescription}
              onChange={(e) => {
                setFieldValue(name + '.extendedFieldDescription', e.target.value);
              }}
            />
          </ErrorTooltip>
        </td>
      </tr>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Field"
        value={`Are you sure you want to delete this field?`}
        handleSubmit={handleConfirmDelete}
      />
      {isLoading && <PageLoader />}
    </>
  );
}
export default withField(ExtendedRepositoryTable);
